import React, { FC, ReactNode } from 'react';
import styles from './styles.module.scss';

interface IProps {
  text: ReactNode;
}

const CaseDescription: FC<IProps> = ({ text }) => (
  <div className={styles.description}>{text}</div>
);

export { CaseDescription };
